export function coachPoolTeamsReducer(state, action) {
  switch (action.type) {
    case "loadTeams":
      return {
        ...state,
        coachPool: action.coachPool,
        teams: action.teams,
      };
    case "hideModal":
      return {
        ...state,
        coachPool: null,
        teams: null,
      };
    default:
      throw new Error();
  }
}
